import React from 'react';
import { Form, Row, Button, Spinner } from 'react-bootstrap';
import { Constants } from "../../constants";
import axios, { AxiosRequestConfig } from 'axios';
import SiteMenu from "../menu";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import '../../App.css';



function currencyFormat(num) {
    return '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

class DownloadCertAdminPage extends React.Component {

    constructor(props) {
        super(props);

        let userExists = !(props.location.state == null || props.location.state.user == null);

        this.state = {
            user: userExists ? props.location.state.user : {},
            loading: false,
            registrationID:''
        };

        this.handleFormChange = this.handleFormChange.bind(this);
        this.downloadFile = this.downloadFile.bind(this);
        this.showButton = this.showButton.bind(this);
    }

    handleFormChange(event) {
        this.setState({
            registrationID: event.target.value
        });
    }

    showButton() {
        if (this.state.loading) {
            return <Button style={{ marginLeft: '15px', backgroundColor: '#1F419B', width: 'auto' }} variant="primary" disabled>
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true" />
                <span className="visually-hidden">Loading...</span>
            </Button>;
        }
        else {
            return <Button style={{ marginLeft: '15px', backgroundColor: '#1F419B', width: 'auto' }} onClick={this.downloadFile} variant="primary">Download</Button>
        }
    }

    downloadFile() {
        this.setState({ loading: true });
        axios.get(`${Constants.apiURL}/api/Training/DownloadCertificate`, {
            params: {
                user: this.state.user.username,
                registrationID: this.state.registrationID
            },
            responseType: "blob"
        }).then(response => {
            this.setState({ loading: false });

            let blob = new Blob([response.data], { type: "application/pdf" }),
                downloadUrl = window.URL.createObjectURL(blob),
                filename = "",
                disposition = response.headers["content-disposition"];

            if (disposition && disposition.indexOf("attachment") !== -1) {
                let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
                    matches = filenameRegex.exec(disposition);

                if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, "");
                }
            }
            else {
                alert('Error downloading certificate. Please confirm the registration ID is correct. Remember certificates are available only for registrants marked as "attended."');
                return;
            }

            let a = document.createElement("a");
            if (typeof a.download === "undefined") {
                window.location.href = downloadUrl;
            } else {
                a.href = downloadUrl;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
            }
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            alert('Error downloading certificate. Please confirm the registration ID is correct. Remember certificates are available only for registrants marked as "attended."');
            console.log('request failed', response)
        });
    }

    render() {
        return (
            <div>
                <SiteMenu user={this.state.user} currentPage='customerStatementPage' />
                <Form onSubmit={this.downloadFile} noValidate >
                    <Form.Label className="form-header" style={{ padding: '10px 0px 0px 10px', marginBottom: 0 }}>Training Certificate Download</Form.Label>
                    <br />
                    <Form.Label style={{ fontStyle: 'italic', fontSize: '16px', padding: '0px 0px 0px 10px' }}>To download a user's training certification, please enter their registration ID below.</Form.Label>
                    <Row>
                        <Form.Label style={{ width: 'auto', alignSelf:'self-end', fontSize:'18px', marginLeft:'10px' }}>Registration ID (REG-XXXXX)</Form.Label>
                        <Form.Control style={{ width: 'auto' }} type="input" name="regID" value={this.state.registrationID} onChange={this.handleFormChange} />
                        {this.showButton()}
                    </Row>
                </Form>
            </div>
        );
    }
}
export default DownloadCertAdminPage;